import { render, staticRenderFns } from "./DragImg.vue?vue&type=template&id=515f5728"
import script from "./DragImg.vue?vue&type=script&lang=js"
export * from "./DragImg.vue?vue&type=script&lang=js"
import style0 from "./DragImg.vue?vue&type=style&index=0&id=515f5728&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports